import { Component, Output } from '@angular/core';
import { User } from './auth/_models';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './auth/_services';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

//declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'plataforma';
  currentUser: User;
  exibeMenu = true;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public translate: TranslateService
  ) {
    this.authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    translate.addLangs(['pt-br', 'en']);
    translate.setDefaultLang('pt-br');
    translate.use('pt-br');
    /*
		### Language selection, can be used when we get an english translation file available for application

		const browserLang = translate.getBrowserLang();
		translate.use(browserLang.match(/pt-br|en/) ? browserLang : 'pt-br');
		*/
    //teste-pipeline
  }

  public onRouterOutletActivate(event: any) {
    if (event.route && event.route.component && event.route.component.name == 'LoginComponent') {
      this.exibeMenu = false;
    } else {
      this.exibeMenu = true;
    }
  }
}
